import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export type TCurrencyOperation = 'order' | 'withdrawal' | 'requisite';

export interface TCurrencyCapability {
  code: string;
  name: string;
  symbol: string;
  amount_scale: number;
  amount_step: string;
  min_amount: string;
  max_amount: string | null;
  payment_methods: string[];
}

export const CurrencyApi = createApi({
  reducerPath: 'CurrencyApi',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getCurrencies: build.query<TCurrencyCapability[], TCurrencyOperation>({
      query: (operation) => ({ url: '/currencies/', method: 'GET', params: { operation } }),
    }),
  }),
});

export const { useGetCurrenciesQuery } = CurrencyApi;
